module.exports = __webpack_public_path__ + "frontend/images/secure/keep-9c17f1edd7e5b8f5dedb4e68ee86732e.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/secure/keep.jpg
// module id = 329
// module chunks = 2